import { InjectionToken } from '@angular/core';
import { CustomExerciseServiceInterface } from './exercise.interface';

export const EXERCISE_TOKEN = new InjectionToken<CustomExerciseServiceInterface>('ExerciseToken');
